import React, { useMemo } from 'react';
import { Popover } from 'antd';
import { HtmlContent } from '@client/utils/html_content';
import { stripHtml } from '@client/utils/stripHtml';

/**
 * Component that truncates text and shows full text in popover on hover.
 * Handles HTML content safely by stripping tags before measuring/truncating.
 */
const TruncatedText = ({
  text,
  maxLength = 35,
  suffix = '...',
  popoverProps = {},
  textProps = {},
  ...props
}) => {
  const { isLong, displayText } = useMemo(() => {
    if (!text) return { isLong: false, displayText: '' };
    const raw = String(text);
    const plain = stripHtml(raw);
    const long = plain.length > maxLength;
    return {
      isLong: long,
      displayText: long ? plain.substring(0, maxLength) + suffix : raw,
    };
  }, [text, maxLength, suffix]);

  if (!text) return <span {...textProps} {...props}></span>;

  if (!isLong) {
    return (
      <span {...textProps} {...props}>
        <HtmlContent html={String(text)} />
      </span>
    );
  }

  return (
    <Popover
      content={
        <div style={{ maxWidth: 300, wordWrap: 'break-word' }}>
          <HtmlContent html={String(text)} />
        </div>
      }
      title={null}
      trigger="hover"
      placement="top"
      {...popoverProps}
    >
      <span
        style={{
          cursor: 'help',
          borderBottom: '1px dotted #ccc',
          ...textProps.style,
        }}
        {...textProps}
        {...props}
      >
        {displayText}
      </span>
    </Popover>
  );
};

export default TruncatedText;
